module.exports = __webpack_public_path__ + "img/text.210cdc19.svg";